var map = {
	"./de/registration.svg": 67739,
	"./en/registration.svg": 36227,
	"./es/registration.svg": 82928,
	"./fr/registration.svg": 84940,
	"./it/registration.svg": 96969,
	"./ko/registration.svg": 78770,
	"./pl/registration.svg": 51616,
	"./pt/registration.svg": 62856,
	"./ru/registration.svg": 90066,
	"./tr/registration.svg": 89090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79406;